<h2 class="title-white">
    <ng-container i18n *ngIf="hurryUp">Hurry up</ng-container>
    <ng-container i18n *ngIf="!hurryUp"><ng-content></ng-content></ng-container>
</h2>

<div class="count-down-container">
    <app-count-down
        *ngIf="countDownEnabled"
        [initialTimeInSeconds]="initialTimeInSeconds"
        (countDownProgressed)="animate && onCountDownProgress($event)"
    ></app-count-down>
</div>
